import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_centerX() {
  return (this.get_left_woprgw_k$() + this.get_right_ixz7xv_k$()) / 2;
}
function get_centerY() {
  return (this.get_top_18ivbo_k$() + this.get_bottom_bj8ras_k$()) / 2;
}
var RecyclerViewPlaceableClass;
function RecyclerViewPlaceable() {
  if (RecyclerViewPlaceableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'RecyclerViewPlaceable');
    RecyclerViewPlaceableClass = $;
  }
  return RecyclerViewPlaceableClass;
}
//region block: exports
export {
  get_centerX as get_centerX2in8u6xgwmvfr,
  get_centerY as get_centerY2o32deip08ur4,
  RecyclerViewPlaceable as RecyclerViewPlaceable30p36x6wixz5i,
};
//endregion

//# sourceMappingURL=RecyclerViewPlaceable.mjs.map
